import { forwardRef } from 'react';
import { gtmEventType } from '@Components/Utilities/SandhillsConstants';
import { gtmPushEvent } from '@Components/Utilities/SandhillsUtility';
import translator from '@Components/Utilities/Translator';
import ActionButton from '@Components/Shared/ActionButton';
import { ThemedLinkButton } from '@Components/MuiWrappers/Button';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
import throttle from 'lodash/throttle';
import Icon from '@mui/material/Icon';

const TextMessage = forwardRef((props, ref) => {
    const currentUser = useRecoilValue(atoms.currentUser);

    const onClick = throttle((e) => {
        if (!currentUser.IsSearchEngine) {
            if (props.onPhoneClickToTrack) {
                props.onPhoneClickToTrack(e, props.messagePhone, 'Retail Text Phone');
            }

            gtmPushEvent(gtmEventType.sms);
        }
    }, 500);

    const getEncodedMessageBody = () => {
        return encodeURIComponent(translator.translate('sandhills.textquestion.questionabout') + ' ' + props.messageBody);
    };

    return (
        <>
            {props.isDetailPage ?
                <ThemedLinkButton variant='text' size='small' href={'sms:' + props.messagePhone + '?&body=' + getEncodedMessageBody()} className='dealer-contact__link' onClick={onClick}>
                    <Icon baseClassName='fas' className='fa-mobile-alt gtm-noclick dealer-contact__icon' sx={{ color: 'contrastDefault.main' }} />
                    <span className='gtm-noclick dealer-contact__link-text'>{props.buttonText}</span>
                </ThemedLinkButton>
                :
                <ActionButton
                    ID={'text-' + props.Id}
                    phoneType='Retail Text Phone'
                    url={'sms:' + props.messagePhone + '?&body=' + getEncodedMessageBody()}
                    className={(props.className || '') + ' dealer-contact__link'}
                    iconClass={(props.iconClass || '') + ' fas fa-mobile-alt gtm-noclick dealer-contact__icon'}
                    iconText={props.iconText || ''}
                    buttonClass={(props.buttonClass || '') + ' gtm-noclick'}
                    buttonText={props.buttonText || translator.translate('sandhills.textseller')}
                    onClick={onClick}
                    ref={ref}
                />}
        </>
    );
});

export default TextMessage;